import { Component, HostListener, input, InputSignal, signal } from '@angular/core';
import { MatCell, MatColumnDef, MatHeaderCell, MatHeaderRow, MatRow, MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { TransformUnderscoreToSpacePipe } from '../../pipes/tranform-underscore-to-space.pipe';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-empty-table',
  imports: [
    MatTableModule,
    MatColumnDef,
    MatHeaderCell,
    MatCell,
    MatRow,
    TransformUnderscoreToSpacePipe,
    TitleCasePipe
  ],
  templateUrl: './empty-table.component.html',
  styleUrl: './empty-table.component.scss'
})
export class EmptyTableComponent {
  emptyTable = [{}, {}, {}, {}, {}];
  readonly dataSource: MatTableDataSource<any> = new MatTableDataSource<any>(this.emptyTable);

  readonly displayedColumns: InputSignal<string[]> = input.required<string[]>();
  readonly columnWidth: InputSignal<number | undefined> = input.required<number | undefined>();
  readonly columnWidthResponsiveMap: InputSignal<Record<string, { base: number; xl?: number; lg?: number; md?: number; sm?: number }> | undefined>
    = input<Record<string, { base: number; xl?: number; lg?: number; md?: number; sm?: number }> | undefined>();

  private viewportWidth = signal<number>(typeof window !== 'undefined' ? window.innerWidth : 1920);

  @HostListener('window:resize')
  onResize(): void {
    this.viewportWidth.set(window.innerWidth);
  }

  getWidth(column: string): number | undefined {
    const responsiveMap = this.columnWidthResponsiveMap();
    const base = this.columnWidth();

    if (responsiveMap && responsiveMap[column]) {
      const cfg = responsiveMap[column];
      const w = this.viewportWidth();
      if (w < 768 && cfg.sm) return cfg.sm;
      if (w < 1024 && cfg.md) return cfg.md;
      if (w < 1280 && cfg.lg) return cfg.lg;
      return cfg.base ?? base;
    }

    return base;
  }
}
